import { Swiper, SwiperSlide} from 'swiper/react';
import { Autoplay, FreeMode, Grid } from 'swiper/modules';
/* import CSS */
import "./styles/CarouselLocals.css"

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/free-mode';
import 'swiper/css/grid';


export const CarouselLocals = (props) => {

    let items = props.items;
    let reverseDirection = props.reverseDirection;
    let breakpoints = props.breakpoints
    let direction = props.vertical
    let initialSlide = props.initialSlide

    return(
    <Swiper
      modules={[Autoplay]}
      breakpoints={breakpoints}
      direction={direction ? 'vertical' : 'horizontal'}
      loop={props.loop ? props.loop : true}
      spaceBetween={props.spaceBetween ? props.spaceBetween : '50'}
      autoplay={{ delay: 0, reverseDirection: reverseDirection, disableOnInteraction: false}}
      speed={props.speed ? props.speed : 0}
      slidesPerView={props.slidesPerView}
      className={props.className}
      allowTouchMove={false}
      preventClicks={true}
      preventInteractionOnTransition={true}
      simulateTouch={false}
      passiveListeners={true}
      followFinger={false}
      touchMoveStopPropagation={true}
      mousewheel={true}
      touchReleaseOnEdges={true}
      threshold={0}
    >
        {items.map((item, index) => (

            <SwiperSlide key={index} className='CarouselLocal_Slide swiper-no-swiping'>
                {item}
            </SwiperSlide>
        ))}
    </Swiper>
    )

}